var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{class:_vm.classes,attrs:{"name":"form-back","color":"primary","disable":_vm.disable,"label":_vm.title},on:{"click":_vm.backForm}})}
var staticRenderFns = []

export { render, staticRenderFns }